// extracted by mini-css-extract-plugin
export default {"root":"footer-module___root___bbdb29c9","buttonsSection":"footer-module___buttonsSection___ed19fc24","content":"footer-module___content___bb9f7a55"};